import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";

export default function Registry() {
  const [items, setItems] = useState([]);
  const [query, setQuery] = useState("");

  const load = async () => {
    try {
      const res = await axios.get(`${API}/registry`);
      setItems(res.data);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load registry");
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(it =>
      it.display_name.toLowerCase().includes(q) ||
      it.responsible_name.toLowerCase().includes(q) ||
      it.location.toLowerCase().includes(q)
    );
  }, [items, query]);

  return (
    <div>
      <div className="text-center">
        <span className="badge-red">Public Registry</span>
        <h2 className="section-title text-3xl guild-display">Accredited Institutions & Businesses</h2>
        <p className="text-yellow-100/80 mt-2 max-w-2xl mx-auto">This registry lists approved entities certified by the Academic Guild. Only approved entries appear here.</p>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
        <div className="md:col-span-2">
          <Label className="text-yellow-300">Search</Label>
          <Input className="mt-2 guild-input" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by name or location" />
        </div>
        <div className="flex gap-2 md:justify-end">
          <Button onClick={load} className="btn-gold">Refresh</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6">
        {filtered.map((item) => (
          <Card key={item.id} className="guild-card">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                <span>{item.display_name}</span>
                <Badge style={{ background: 'rgba(212,175,55,0.18)', color: '#ffffff', border: '1px solid rgba(212,175,55,0.35)' }}>Accredited by the Academic Guild</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-sm text-yellow-100/90">
                <div><span className="font-semibold">Type:</span> {item.applicant_type}</div>
                <div><span className="font-semibold">Responsible:</span> {item.responsible_name}</div>
                <div><span className="font-semibold">Location:</span> {item.location}</div>
                <div className="mt-2"><span className="font-semibold">Certification on file:</span> Yes</div>
              </div>
            </CardContent>
          </Card>
        ))}
        {filtered.length === 0 && (
          <div className="text-yellow-100/70">No entries match your search.</div>
        )}
      </div>
    </div>
  );
}